<template>
  <div class="uk-height-1-1">
    <div class="main-bg" :style="`background-image:url(${background})`"></div>
    <!--    <MobileHeader></MobileHeader>-->
    <b-container class="uk-height-1-1">
      <b-row class="uk-width-1-1 uk-height-1-1">
        <!--Десктоп-->
        <div class="uk-visible@l">
          <!--Свернутое меню -->
          <DesktopRightMenuClosed
            :style="isAvailable(!isOpened)"
            @change="toggle"
          ></DesktopRightMenuClosed>
          <!--Развернутое меню -->
          <DesktopRightMenuOpened
            :style="isAvailable(isOpened)"
            @change="toggle"
          ></DesktopRightMenuOpened>
        </div>
        <DesktopSidebar></DesktopSidebar>
        <DesktopMainBlock></DesktopMainBlock>
        <!--Мобильное приложение-->
        <h3
          class="uk-hidden@l uk-animation-slide-bottom-medium uk-text-center uk-flex uk-flex-center uk-width-1-1"
        >
          На данный момент мобильная версия недоступна
        </h3>
        <!--        <MobileMainBlock v-if="isMobile"></MobileMainBlock>-->
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import MobileMainBlock from "@/views/layout/mobile/MobileMainBlock";
import DesktopMainBlock from '@/views/layout/desktop/DesktopMainBlock'
import DesktopSidebar from '@/views/layout/desktop/sidebar/DesktopSidebar'
import DesktopRightMenuOpened from '@/views/layout/desktop/right_menu/opened/DesktopRightMenuOpened'
import DesktopRightMenuClosed from '@/views/layout/desktop/right_menu/closed/DesktopRightMenuClosed'
// import MobileHeader from "@/views/layout/mobile/MobileHeader";

export default {
  name: 'Main',
  data: () => ({
    isOpened: false,
    hide: 'display: none !important',
    show: 'display: inline-block !important',
    background: require('@/assets/images/background.png')
  }),
  components: {
    // MobileHeader,
    // MobileMainBlock,
    DesktopSidebar,
    DesktopMainBlock,
    DesktopRightMenuClosed,
    DesktopRightMenuOpened
  },
  methods: {
    isAvailable(val) {
      return val ? this.show : this.hide
    },
    toggle(val) {
      this.isOpened = val
    }
  }
}
</script>
